var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-dzsw {\n  width: 100%;\n  text-align: center;\n  height: 100vh;\n  background: #fff url(" + escape(require("../assets/dzsw-03.png")) + ") center bottom no-repeat;\n  background-size: 100% auto;\n}\n.page-dzsw img {\n  width: 96%;\n  margin-top: 5px;\n}\n", ""]);

// exports
